import React from 'react'
import { Button } from 'primereact/button'
import './styles.scss'

export const SidebarBottom = () => {
  const handleSupportClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    
    // Abrir el formulario de soporte en una nueva pestaña
    window.open('https://forms.office.com/r/42p9byMbRp', '_blank')
  }

  return (
    <div className="sidebar-bottom">
      <Button
        className="p-button p-button-text p-button-sm sidebar-support-button"
        onClick={handleSupportClick}
        icon="pi pi-question-circle"
        label="Soporte"
      />
    </div>
  )
}
